exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-106c86ed] {\n  margin: 30px;\n}\n.dashboard-text[data-v-106c86ed] {\n  font-size: 30px;\n  line-height: 46px;\n}\n.dashboard-tips[data-v-106c86ed] {\n  font-size: 12px;\n  color: #666;\n}\n", ""]);

// exports
